import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { API } from '@constants/app.constants';
import { HeaderLoader } from '@utils/headerLoader';
import { StorageLoader } from '@utils/storageLoader';

@Injectable({ providedIn: 'root' })
export class SessionRefreshService {
  private inFlight: Promise<boolean> | null = null;

  constructor(
    private http: HttpClient,
    private headerLoader: HeaderLoader,
    private storageLoader: StorageLoader,
  ) {}

  refresh(): Promise<boolean> {
    if (this.inFlight) return this.inFlight;

    this.inFlight = this.doRefresh().finally(() => {
      this.inFlight = null;
    });

    return this.inFlight;
  }

  private async doRefresh(): Promise<boolean> {
    try {
      const refreshToken = await this.storageLoader.getRefreshToken();
      if (!refreshToken) return false;

      const headers = await this.headerLoader.authRefresh();
      const response: any = await firstValueFrom(
        this.http.get(`${API}auth/refresh`, headers),
      );

      const body = response?.body ?? response;
      const data = body?.data ?? body;

      if (!data?.access_token) return false;

      await this.storageLoader.setToken(data.access_token);

      if (data.refresh_token) {
        await this.storageLoader.setRefreshToken(data.refresh_token);
      }

      if (data.user) {
        await this.storageLoader.setUser(data.user);
      }

      return true;
    } catch {
      return false;
    }
  }
}
